import React from 'react';
import { Icons } from '@shared/constants';

/**
 * Benefit list for the paid-launch paywall (card A1).
 *
 * Replaces the old FREE-vs-MEMBERS comparison table (`MembershipFeatureList`),
 * which is a freemium relic — with no free tier at launch there is nothing to
 * compare against.
 *
 * Simplified per Justin's 2026-07-20 paywall redesign: one "unlimited access"
 * lead + four short checkmarks, no per-benefit body copy, and NO trial
 * reassurance strip here — trial terms live in the paywall's single terms
 * line, so this list reads identically for trial, winback, and resubscribe.
 *
 * `tone="dark"` serves the green funnel paywall (2026-07-21). Same list, same
 * order, same words — only the colours change, so the two paywall surfaces
 * never drift on what a membership actually includes.
 */

// One product (2026-10-07): the debt tools are in the membership too.
const BENEFITS = [
  'Secure spend tracking',
  'Built-in impulse shopping blockers',
  'Personalized insights',
  'Debt goals and payoff planning',
  'FREE Subscription finder',
];

export const SpendingToolsBenefits: React.FC<{ tone?: 'light' | 'dark' }> = ({ tone = 'light' }) => {
  const dark = tone === 'dark';
  return (
    <div className="space-y-2.5">
      <p className={`text-sm font-medium ${dark ? 'text-cloud' : 'text-growth'}`}>
        Your membership comes with unlimited access:
      </p>
      {BENEFITS.map((benefit) => (
        <div key={benefit} className="flex items-center gap-2.5">
          {/* On dark the disc is SOLID foliage with a growth check — a foliage
              mark on a foliage-tinted disc all but disappears against bg-growth.
              Same treatment as the trial timeline's "Today" stop. */}
          <div className={`shrink-0 w-5 h-5 rounded-full flex items-center justify-center ${dark ? 'bg-foliage' : 'bg-foliage/20'}`}>
            <Icons.Check className="w-3 h-3 text-growth" strokeWidth={dark ? 3 : undefined} />
          </div>
          <span className={`text-sm ${dark ? 'text-cloud' : 'text-growth/80'}`}>{benefit}</span>
        </div>
      ))}
    </div>
  );
};
